jQuery(document).ready(function(){
 


  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() > 200) {
      jQuery("header.main").addClass("scrolled");
    }
  });

  jQuery(document).on("scroll", function() {
    if (jQuery(this).scrollTop() < 200) {
      jQuery("header.main").removeClass("scrolled");
    }
  });

});
